type GetRedirectUrlIfTempPasswordOptions = {
  shouldViewCountrySelectionView: boolean;
  routerAsPath: string;
  applicationId: string | null | undefined | string[];
};
export const getRedirectUrlIfTempPassword = ({
  shouldViewCountrySelectionView,
  routerAsPath,
  applicationId,
}: GetRedirectUrlIfTempPasswordOptions) => {
  if (shouldViewCountrySelectionView) {
    let redirectToUrl = `/auth/signup?redirectTo=${routerAsPath}&newPasswordRequired=true`;
    if (applicationId) {
      redirectToUrl = `${redirectToUrl}&application_id=${applicationId}`;
    }
    return redirectToUrl;
  }
  return '/auth/reset-password';
};
